/**
 * `6899` — *move {item, itemMapping} to {board, targetBoardId}*.
 *
 * One production node (recipe 62693104, "when button clicked move item to board") and the
 * replacement chain of static recipes `180` and `181`.
 *
 * monday moves the item itself, it does not copy it: the port maps onto `items.moveItemToBoard`,
 * which already owns the column mapping, the subitems and the `move_pulse_into_board` activity
 * row. The `itemMapping` slot is kept for its `groupId` (the group on the target board) and its
 * column pairs, which the service's `columnsMapping` consumes.
 */
import { z } from 'zod';
import { defineAction } from '../block.js';
import { itemMappingSchema, mappingSourceColumns } from '../item-mapping.js';
import { numberish } from '../values.js';
export const moveItemToBoardParams = z.object({
    targetBoardId: numberish.nullable().default(null),
    itemMapping: itemMappingSchema,
    sourceBoardId: numberish.nullable().optional(),
});
export const moveItemToBoardAction = defineAction({
    id: '6899',
    kind: 'action',
    app: 'monday',
    sentencePartial: 'move {item, itemMapping} to {board, targetBoardId}',
    paramsSchema: moveItemToBoardParams,
    executable: true,
    references: (params) => [
        ...(params.targetBoardId === null ? [] : [{ kind: 'board', id: String(params.targetBoardId) }]),
        ...mappingSourceColumns(params.itemMapping).map((columnId) => ({ kind: 'column', id: columnId })),
    ],
    async execute(context, params) {
        if (params.targetBoardId === null)
            return { skipped: 'no_target_board' };
        if (context.itemId === null)
            return { skipped: 'no_item' };
        const move = context.services.moveItemToBoard;
        if (move === undefined)
            return { skipped: 'unsupported' };
        const moved = await move({
            itemId: context.itemId,
            boardId: String(params.targetBoardId),
            groupId: params.itemMapping.groupId,
        });
        return { itemId: moved.itemId, boardId: String(params.targetBoardId), groupId: params.itemMapping.groupId };
    },
});
//# sourceMappingURL=6899.js.map